import { render, staticRenderFns } from "./FlightSearchForm.vue?vue&type=template&id=228ecc5c&scoped=true"
import script from "./FlightSearchForm.vue?vue&type=script&lang=js"
export * from "./FlightSearchForm.vue?vue&type=script&lang=js"
import style0 from "./FlightSearchForm.vue?vue&type=style&index=0&id=228ecc5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228ecc5c",
  null
  
)

export default component.exports